import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { getLeafChildrenData } from 'timeSheet/utils';
import { ApproveAggregateRenderer, ApproveRenderer } from 'timeSheet/components/CellRenderers';

const useApproveColumn = ({ approveTimeSheet, editOSTimeSheet, mappedSupplierBranches, suppressAggregate = false }) => {
  const { t, isRtl } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) {
        if (suppressAggregate) return null;
        return ApproveAggregateRenderer({
          rowData: { summarized: false, subRows: getLeafChildrenData(params.node) }
        });
      }

      return ApproveRenderer({
        rowData: params.data,
        columnData: { approveTimeSheet, editOSTimeSheet, mappedSupplierBranches }
      });
    },
    [approveTimeSheet, editOSTimeSheet, mappedSupplierBranches, suppressAggregate]
  );

  return useMemo(
    () => ({
      field: 'approved',
      headerName: t('columnHeaderApprovedPayroll'),
      pinned: isRtl ? 'right' : 'left',
      minWidth: 80,
      width: 80,
      suppressMovable: true,
      resizable: false,
      sortable: false,
      suppressColumnsToolPanel: true,
      cellRenderer
    }),
    [t, cellRenderer, isRtl]
  );
};

export default useApproveColumn;
